var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobTest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.4V13C19 15.4 19 16.6 17.8 17.8C16.6 19 15.4 19 13 19H9.4M1 10.6V7C1 4.6 1.6 3.4 2.5 2.5C3.4 1.6 4.6 1 7 1H10.6M4.6 12.4H5.8M15.4 12.4H14.2M14.2 12.4V11.2C14.2 9.4 14.2 8.8 13 8.8C11.8 8.8 12.4 7.6 11.2 7.6H8.8C7.6 7.6 8.2 8.8 7 8.8C5.8 8.8 5.8 9.4 5.8 11.2V12.4M14.2 12.4H11.8M5.8 12.4H8.2M8.2 12.4C8.2 12.4 8.2 10.3 10 10.3C11.8 10.3 11.8 12.4 11.8 12.4M8.2 12.4H11.8",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobTest);
export default __webpack_public_path__ + "static/media/mob_test.0ff61ad2d4bdf58d171197fc5d9d9907.svg";
export { ForwardRef as ReactComponent };